<header>
  <div
    class="container-fluid responsive-fixed-header px-0 wow fadeIn"
    data-wow-delay="0.1s"
  >
    <nav
      #navbar
      class="navbar navbar-expand-lg py-lg-0 px-lg-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <a href="index.html" class="navbar-brand ms-4 ms-lg-0">
        <img src="assets/img/mykadainew.png" class="mykadai-logo" />
      </a>
      <button
        type="button"
        class="navbar-toggler me-4"
        (click)="toggleNavbar()"
      >
        <span class="navbar-toggler-icon">
          <i
            class="bi bi-list h1"
            [ngClass]="isNavbarCollapsed ? 'text-black' : 'text-black'"
          ></i>
        </span>
      </button>
      <div
        [ngClass]="{
          'collapse navbar-collapse': true,
          show: !isNavbarCollapsed
        }"
        id="navbarCollapse"
      >
        <div class="navbar-nav ms-auto p-4 p-lg-0">
          <a routerLink="/" fragment="home" class="nav-item nav-link active"
            >Home</a
          >
        </div>
      </div>
    </nav>
  </div>
</header>
<!-- NAVBAR (Sidebar toggle for mobile) -->
<nav class="navbar navbar-dark sticky-top d-lg-none py-3 nav-content">
  <div class="container-fluid">
    <a class="navbar-brand text-white fw-semibold">Table of Contents</a>
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</nav>

<!-- Offcanvas Sidebar (for mobile) -->
<div
  class="offcanvas offcanvas-start text-bg-dark"
  tabindex="-1"
  [class.show]="isSidebarOpen"
  (click)="closeSidebar()"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">Table of Contents</h5>
    <button
      type="button"
      class="btn-close btn-close-white"
      (click)="closeSidebar()"
    ></button>
  </div>
  <div class="offcanvas-body p-3">
    <!-- same sidebar content -->
    <ul class="list-unstyled mb-0">
      <li class="mt-3">
        <h5>Product Upload Workflow</h5>
        <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Introduction"
              >Introduction</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="shop-registration"
              >Shop Registration</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Shop-Setup-Workflow"
              >Shop Setup Workflow</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Shop-Products"
              >My Shop Products</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Orders"
              >My Orders</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Payments"
              >Payments</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/product-upload"
              fragment="Upload Screen"
              >Upload Screen</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<div class="d-flex manual-layout">
  <!-- Sidebar -->
  <aside class="sidebar text-white p-3 top-0 start-0 vh-100 d-none d-lg-block">
    <h4 class="fw-semibold mb-3 pt-lg-5 mt-lg-3 pt-0 mt-0">
      Table of Contents
    </h4>
    <ul class="list-unstyled mb-0">
      <li class="mt-3">
        <h5>Product Upload Workflow</h5>
        <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Introduction"
              >Introduction</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="shop-registration"
              >Shop Registration</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Shop-Setup-Workflow"
              >Shop Setup Workflow</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Shop-Products"
              >My Shop Products</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Orders"
              >My Orders</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Payments"
              >Payments</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              (click)="goToUploadScreen()"
              role="button"
              >Upload Screen</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </aside>
  <!-- Main Content -->
  <main class="flex-grow-1 bg-light">
    <section class="manual-details bg-white p-4 rounded shadow-sm">
      <!-- HOME SCREEN -->

      <article id="Introduction">
        <h3>Introduction</h3>
        <p>
          MyKadai is an all-in-one e-commerce platform that simplifies online
          shopping and vendor management. It empowers local shop owners with
          tools to manage products, track orders, and monitor sales efficiently.
        </p>
        <p>
          This documentation serves as a comprehensive guide for Shop Owners
          using the MyKadai Web App.
        </p>

        <h5>Platform Components</h5>
        <ul>
          <li>
            <strong>Customer Mobile App:</strong> Built for a seamless shopping
            experience.
          </li>
          <li>
            <strong>Shop Owner Web App:</strong> Developed for allowing vendors
            to manage products, orders, and inventory.
          </li>
        </ul>

        <h5>Accessing the Vendor Web App</h5>
        <ul class="responsive-link-list">
          <li>
            <strong>URL:</strong>
            <a
              href="https://mykadai.varnik.cloud/#/"
              target="_blank"
              class="break-link"
            >
              https://mykadai.varnik.cloud/#/
            </a>
          </li>
        </ul>

        <h5>User Type Selection</h5>
        <p>Upon accessing the platform, select your user type:</p>
        <ul>
          <li>
            The website dynamically updates content (About, Features, Pricing,
            How It Works) based on the selected type.
          </li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/user-type.png"
            alt="Vendor App Home Screen"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>

        <h5>Choose:</h5>
        <ul>
          <li><strong>Join Now:</strong> For new shop owners to register.</li>
          <li>
            <strong>Login:</strong> For existing shop owners using their
            registered mobile number and password.
          </li>
        </ul>
      </article>

      <article id="shop-registration">
        <h3>Shop Registration</h3>
        <p><strong>For New Shop Owners:</strong></p>
        <ol>
          <li>Click <strong>Join Now</strong>.</li>
          <li>Fill in your shop and personal details.</li>
          <li>Submit the registration form.</li>
        </ol>
        <p>
          ✅ Once submitted, our admin team will verify and approve your
          application.
        </p>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/shop-registration.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
      </article>

      <article id="Shop-Setup-Workflow" class="mt-4">
        <h3>Shop Setup Workflow</h3>
        <h5>1. Register Your Shop</h5>
        <ul>
          <li>Post-approval, log in to your dashboard.</li>
          <li>Navigate to the <strong>New Shop</strong> section.</li>
          <li>
            Enter your shop details (name, address, etc.) to create your shop
            profile.
          </li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/new-shop.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>

        <h5>2. Add Products to Your Shop</h5>
        <h5>Option 1: Import from MyKadai Inventory</h5>
        <ul>
          <li>Go to: <strong>Product → Product Import</strong></li>
          <li>
            Select:
            <ul>
              <li>Shop Name</li>
              <li>Category &amp; Sub-category</li>
            </ul>
          </li>
          <li>The system displays available inventory products.</li>
          <li>Uncheck/remove any unwanted products before import.</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/product-shop.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>

        <h5>Option 2: Add New Custom Products</h5>
        <ul>
          <li>Navigate to: <strong>Product → Add New Product</strong></li>
          <li>Enter product details, upload image(s), set MRP/SRP.</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/new-product.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
      </article>

      <article id="My-Shop-Products" class="mt-4">
        <h3>My Shop Products</h3>
        <p>View and manage all products listed under your shop:</p>
        <ul>
          <li>Select <strong>Shop Name</strong> from the dropdown.</li>
        </ul>

        <p><strong>Features:</strong></p>
        <ol>
          <li>View complete product list.</li>
          <li>Update MRP &amp; SRP instantly.</li>
          <li>Edit product details.</li>
          <li>Set Active/Inactive status (e.g., for out-of-stock products).</li>
        </ol>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/my-product.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
      </article>

      <article id="My-Orders" class="mt-4">
        <h3>My Orders</h3>
        <p>Track and manage customer orders placed through the mobile app.</p>
        <h5>Order Management</h5>
        <ul>
          <li>View all orders.</li>
          <li>
            Click an order to:
            <ul>
              <li>View detailed information in a popup.</li>
              <li>
                Update Order Status (e.g., Accepted, Ready for Pickup,
                Completed).
              </li>
              <li>Changes reflect on the Customer Mobile App in real time.</li>
            </ul>
          </li>
        </ul>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/my-orders.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/order-details.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
      </article>

      <article id="Payments" class="mt-4">
        <h3>Payments</h3>
        <p>Track payment history and settlement details:</p>
        <ul>
          <li>Navigate to: <strong>Payments</strong></li>
          <li>View shop-based payment transactions and billing cycles.</li>
        </ul>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/payments.png"
            alt="Shop Registration"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>
      </article>

      <article id="Key-features" class="mt-4">
        <h3>Key Features Overview</h3>
        <div class="table-responsive">
        <table class="table table-bordered table-striped" cellspacing="0" cellpadding="6">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Dynamic Website</td>
              <td>Content changes based on user type selection.</td>
            </tr>
            <tr>
              <td>Shop Registration</td>
              <td>Admin approval-based secure onboarding.</td>
            </tr>
            <tr>
              <td>Product Management</td>
              <td>Import from inventory or add custom products.</td>
            </tr>
            <tr>
              <td>Real-time Orders</td>
              <td>View &amp; manage live customer orders.</td>
            </tr>
            <tr>
              <td>Pricing Control</td>
              <td>Update MRP and SRP easily.</td>
            </tr>
            <tr>
              <td>Product Status</td>
              <td>Toggle availability status (Active/Inactive).</td>
            </tr>
            <tr>
              <td>Payment Tracking</td>
              <td>Detailed shop-based payment history.</td>
            </tr>
          </tbody>
        </table>
        </div>
      </article>
    </section>
  </main>
</div>
